import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

import store from '../store'

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'home',
        redirect: { name: 'create_business_account2' },
        beforeEnter: (to, from, next) => {
            const isAuthenticated = store.state.isAuthenticated
            const paymentStatus = store.state.paymentStatus

            if (isAuthenticated) {
                if (paymentStatus === true) {
                    // ✅ to.query préserve ?open_chat=true dans l'URL cible
                    next({ path: '/business-account/dashboard', query: to.query })
                } else {
                    next({ path: '/All', query: to.query })
                }
            } else {
                next()
            }
        }
    },
    {
        path: '/Business-Suite',
        name: 'Business_Suite',
        component: () => import('../views/Home/Index.vue'),
        meta: {
            layout: 'VuebaseLayout3'
        }
    },

    // login page links
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Home/Login'),
        beforeEnter: (to, from, next) => {
            const ref = to.query.ref || to.query.referral || '';
            if (ref) {
                const closeUrl = `/?ref=${ref}`;
                store.commit('setCloseURL3', closeUrl);
            } else {
                store.commit('setCloseURL3', '/');
            }
            next();
        }
    },
    // dans router/index.js

    {
        path: '/messages',
        name: 'messages',
        component: () => import('@/components/MessagesPage_WhatsApp_Redesign.vue'),
        meta: { requiresAuth: true }
    },

    // forgot_password page links
    {
        path: '/forgot_password',
        name: 'forgot_password',
        component: () => import('../views/Home/ForgotPassword'),

    },
    {
        path: '/ResetPassword',
        name: 'ResetPassword',
        component: () => import('../views/Home/ResetPassword'),

    },
    {
        path: '/dashboard/chat/:count',
        name: 'dashboard.chat',
        component: () => import('../views/Dashboard/Chat'),
    },
    {
        path: '/dashboard/chat_history',
        name: 'chat_history',
        component: () => import('../views/Dashboard/ChatHistory'),
    },
    {
        path: '/notification-setup',
        name: 'notification-setup',
        component: () => import('../views/Dashboard/AnimatedMail'),
        meta: {
            requireLogin: true,  // Nécessite d'être connecté
            title: 'Enable Notifications'
        }
    },

    {
        path: '/dashboard/affiliateMarketing',
        name: 'affiliateZone',
        redirect: '/dashboard/affiliateMarketing/Client',
        component: () => import('../views/Dashboard/AffiliateMarketing/Layout'),
        children: [
            {
                path: 'Client',
                name: 'affiliateZone.client',
                component: () => import('../views/Dashboard/AffiliateMarketing/Client')
            },
            {
                path: 'Withdrawal',
                name: 'affiliateZone.withdrawal',
                component: () => import('../views/Dashboard/AffiliateMarketing/Withdrawal'),
                beforeEnter: async (to, from, next) => {
                    try {




                        const response2 = await axios.get('/api/v1/savings/user-email2/');
                        // Vérifier si l'OTP est vérifié
                        if (!response2.data.email && to.name !== '') {
                            console.warn("Email non trouvé, redirection...");
                            // Vérifier si nous ne sommes pas déjà sur la route "Verification"
                            if (to.name !== 'Check_email_marketer') {
                                return next({ name: 'Check_email_marketer' });
                            }
                        }


                        const response = await axios.get('/api/v1/savings/check-otp/');
                        // Vérifier si l'OTP est vérifié
                        if (!response.data.otpverified && to.name !== 'Check_otp_marketer') {
                            console.warn("OTP non vérifié. Redirection vers Verification.");
                            // Vérifier si nous ne sommes pas déjà sur la route "Verification"
                            if (to.name !== 'Check_otp_marketer') {
                                return next({ name: 'Check_otp_marketer' });
                            }
                        }


                        // Si tout est valide, autoriser la navigation
                        next();
                    } catch (error) {
                        console.error("Erreur lors des vérifications de navigation :", error);
                        return next(); // Rediriger en cas d'erreur
                    }
                }
            },
            {
                path: 'Withdrawal_history',
                name: 'affiliateZone.withdrawal_history',
                component: () => import('../views/Dashboard/AffiliateMarketing/WithdrawalHistory'),

            },
            {
                path: 'Transfert',
                name: 'affiliateZone.transfert',
                component: () => import('../views/Dashboard/AffiliateMarketing/Transfert'),

            },
            {
                path: 'Check_otp',
                name: 'Check_otp_marketer',
                component: () => import('../views/Dashboard/AffiliateMarketing/Check_otp'),
            },

            {
                path: 'Check_email',
                name: 'Check_email_marketer',
                component: () => import('../views/Dashboard/AffiliateMarketing/Check_email')

            },

        ],
    },

    // sign up page links
    {
        path: '/signup',
        name: 'signup',
        component: () => import('../views/Home/SignUp'),
        beforeEnter: (to, from, next) => {
            // ── Preserve query params when entering signup ──
            const ref = to.query.ref || to.query.referral || '';
            if (ref) {
                const closeUrl = `/?ref=${ref}`;
                store.commit('setCloseURL3', closeUrl);
            } else {
                store.commit('setCloseURL3', '/');
            }
            next();
        }
    },
    {
        path: '/create_business_account',
        name: 'create_business_account',
        component: () => import('../views/Home/create_business_account'),

    },
    {
        path: '/create_business_account2',
        name: 'create_business_account2',
        component: () => import('../views/Home/create_business_account2'),
        meta: { layout: null }
    },
    {
        path: '/create_business_account3',
        name: 'create_business_account3',
        component: () => import('../views/Home/create_business_account3'),

    },
    {
        path: '/create_business_account5',
        name: 'create_business_account5',
        component: () => import('../views/Home/create_business_account5'),

    },
    {
        path: '/create_business_account4',
        name: 'create_business_account4',
        component: () => import('../views/Home/create_business_account4'),
        beforeEnter: async (to, from, next) => {
            try {
                const redirectPayload = { name: 'Check_useremail', query: { redirect: to.fullPath } };

                if (!store.state.isAuthenticated) {
                    return next(redirectPayload);
                }


                const response = await axios.get('/api/v1/home/get/user/info/');
                const userData = response.data[0];


                if (!userData?.user) {
                    throw new Error('Invalid user data structure');
                }



                // Vérification finale de l'email
                const userEmail = userData?.user?.email;
                if (!userEmail) {
                    return next(redirectPayload);
                }

                next();
            } catch (error) {
                console.error('Erreur navigation:', error);
                store.commit('setSnackBarMessage', "Erreur de connexion");
                store.commit('setSnackBarColor', "red darken-4");
                store.commit('activateSnackBar', true);
                next(redirectPayload);
            }
        }
    },
    {
        path: '/Check_useremail',
        name: 'Check_useremail',
        component: () => import('../views/Home/Check_useremail'),

    },


    // sign up page two links
    {
        path: '/signup/two',
        name: 'signup_two',
        component: () => import('../views/Home/SignUpStepTwo'),

    },

    // sign up page three links
    {
        path: '/signup/three',
        name: 'signup_three',
        component: () => import('../views/Home/SignUpStepThree'),

    },

    // sign up page three links
    {
        path: '/signup/otp',
        name: 'signup_otp',
        component: () => import('../views/Home/SignUpOTP'),

    },

    // sign up page four links
    {
        path: '/signup/four',
        name: 'signup_four',
        component: () => import('../views/Home/SignUpStepFour'),

    },

    // sign up create campaign page links
    {
        path: '/signup/create/campaign',
        name: 'signup_create_campaign',
        component: () => import('../views/Home/NewCampaign'),

    },

    // about us page links
    {
        path: '/about_us',
        name: 'about_us',
        component: () => import('../views/Home/AboutUs'),

    },

    // product services
    {
        path: '/product_service',
        name: 'product_service',
        component: () => import('../views/Home/ProductService'),

    },

    // our team
    {
        path: '/our_team',
        name: 'our_team',
        component: () => import('../views/Home/OurTeam'),

    },
    {
        path: '/All',
        name: 'All',
        component: () => import('../views/All'),

    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('../views/Savings/Transactions/All'),
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/njangi/requirements',
        component: () => import('@/components/NjangiChecklist.vue'),
    },
    {
        path: '/savings/loans/requirements',
        name: 'LoansRequirements',
        component: () => import('@/components/LoansChecklist.vue'),
    },


    // become a partner
    {
        path: '/become_partner',
        name: 'become_partner',
        component: () => import('../views/Home/BecomePartner'),
        meta: {
            requireLogin: true
        }
    },

    // contact us
    {
        path: '/contact_us',
        name: 'contact_us',
        component: () => import('../views/Home/ContactUs')
    },

    // Dashboard
    {
        path: '/dashboard/info',
        name: 'dashboard',
        component: () => import('../views/Dashboard/Layout'),
        children: [
            {
                path: ':types',
                name: 'dashboard.:types',
                component: () => import('../views/Dashboard/Info')
            },
        ],
        meta: {
            requireLogin: true
        }
    },

    // user profile
    {
        path: '/user_profile',
        name: 'user_profile',
        component: () => import('../views/UserProfile/Layout'),
        children: [
            {
                path: 'account',
                name: 'user_profile.account',
                component: () => import('../views/UserProfile/Account')
            },
            {
                path: 'security',
                name: 'user_profile.security',
                component: () => import('../views/UserProfile/Security')
            },
            {
                path: 'info',
                name: 'user_profile.info',
                component: () => import('../views/UserProfile/Info')
            },
            {
                path: 'identity',
                component: () => import('@/views/UserProfile/IdentityVerification.vue'),
                name: 'identity-verification',
            }
        ],
        meta: {
            requireLogin: true
        }
    },

    // terms and conditions links
    {
        path: '/terms_conditions',
        name: 'terms_conditions',
        component: () => import('../views/Home/TermsConditions')
    },

    // faqs links 
    {
        path: '/faqs',
        name: 'faqs',
        component: () => import('../views/FAQs/Layout'),
        children: [
            {
                path: 'types/:types',
                name: 'faqs.:types',
                component: () => import('../views/FAQs/All')
            },
            {
                path: 'detail/:key',
                name: 'faqs.QA:key',
                component: () => import('../views/FAQs/QA')
            },
        ]
    },



    {
        path: '/business-account/dashboard/hub',
        name: 'DashboardHub',
        component: () => import('../views/Business_account/Dashboard/DashboardHub.vue'),
        meta: {
            title: 'Dashboard Hub',
            requiresAuth: true,
        },
    },
    {
        path: '/business-account/dashboard',
        name: 'dashboard',
        component: () => import('../views/Business_account/Dashboard/All.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: '/business-account/dashboard/client-of-affiliates',
        name: 'dashboard.client_of_affiliates',
        component: () => import('../views/Business_account/Dashboard/ClientOfAffiliates'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },
    {
        path: '/business-account/dashboard/WithdrawHistory',
        name: 'dashboard.WithdrawHistory',
        component: () => import('../views/Business_account/Dashboard/WithdrawHistory'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },
    {
        path: '/business-account/dashboard/DepositHistory',
        name: 'dashboard.DepositHistory',
        component: () => import('../views/Business_account/Dashboard/DepositHistory'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },
    {
        path: '/business-account/dashboard/AddUser',
        name: 'dashboard.AddUser',
        component: () => import('../views/Business_account/Dashboard/AddUser'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },
    {
        path: '/business-account/dashboard/commissions/client',
        name: 'dashboard.ClientCommissions',
        component: () => import('../views/Business_account/Dashboard/ClientCommissions.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },



    {
        path: '/business-account/dashboard/extra-advantages',
        name: 'dashboard.extra_advantages',
        component: () => import('../views/Business_account/Dashboard/ExtraAdvantages'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },
    {
        path: '/business-account/dashboard/pettycash-basic-services',
        name: 'dashboard.pettycash_basic_services',
        component: () => import('../views/Business_account/Dashboard/PettycashBasicServices'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },

    {
        path: '/business-account',
        component: () => import('../views/Business_account/Dashboard/All.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },

    },
    {
        path: '/business-account/PettyCash/Services/Index',
        name: 'pettycash_services',
        component: () => import('../views/Business_account/PettyCash/Services/Index'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,

        },
    },
    {
        path: '/PettyCash/Services/Features',
        name: 'pettycash_features',
        component: () => import('../views/Business_account/PettyCash/Services/Features'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },

    // Affiliate Marketing Course
    {
        path: '/business-account/AffiliateMarketing/Course/Enroll',
        name: 'affiliate_marketing_course',
        component: () => import('../views/Business_account/AffiliateMarketing/Course/Index'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: '/business-account/AffiliateMarketing/Course/Details',
        name: 'affiliate_course_details',
        component: () => import('../views/Business_account/AffiliateMarketing/Course/Details'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: '/business-account/AffiliateMarketing/Course/Enroll',
        name: 'affiliate_enroll',
        component: () => import('../views/Business_account/AffiliateMarketing/Course/Enroll'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: '/business-account/Deposits',
        name: '/business-account_Deposits',
        component: () => import('../views/Business_account/Deposits'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },

    {
        path: '/business-account/Withdrawals',
        name: '/business-account_Withdrawals',
        component: () => import('../views/Business_account/Withdrawals/Layout'),
        children: [
            {
                path: 'request',
                name: 'Business_account_withdrawals.request',
                component: () => import('../views/Business_account/Withdrawals/Request'),
                meta: {
                    layout: 'VuebaseLayout2',
                    requireLogin: true
                }

            },



            {
                path: 'fees',
                name: 'Business_account_withdrawals.fees',
                component: () => import('../views/Business_account/Withdrawals/Fees'),
                meta: {
                    layout: 'VuebaseLayout2',
                    requireLogin: true
                }

            },
            {
                path: 'info',
                name: 'Business_account_withdrawals.info',
                component: () => import('../views/Business_account/Withdrawals/Info'),
                meta: {
                    layout: 'VuebaseLayout2',
                    requireLogin: true
                }
            },


        ],
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }

    },
    {
        path: '/business-account/transactions',
        name: '/business-account_transactions',
        component: () => import('../views/Business_account/Transactions/All'),
        children: [
            {

                path: ':category',
                name: 'business-account_transactions.:category',
                component: () => import('../views/Business_account/Transactions/All'),
                meta: {
                    layout: 'VuebaseLayout2',
                    requireLogin: true,
                },
            },
        ],
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }
    },

    // Register Users
    {
        path: 'register-users',
        name: 'register_users',
        component: () => import('../views/Business_account/UserManagement/Register/Index'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: '/business-account/UserManagement/Register/NewUser',
        name: 'register_new_user',
        component: () => import('../views/Business_account/UserManagement/Register/NewUser'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: '/business-account/BulkRegistration',
        name: 'bulk_registration',
        component: () => import('../views/Business_account/UserManagement/Register/BulkRegistration'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    {
        path: ':All.vue',
        name: '',
        component: () => import('../views/Business_account/Dashboard/VideoTutorial/All.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }

    },
    {
        path: '/business-account/dashboard/video-tutorial',
        name: 'dashboard.video_tutorial',
        component: () => import('../views/Business_account/Dashboard/VideoTutorial/All.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }


    },
    {
        path: 'VideoCard',
        name: 'VideoCard',
        component: () => import('../views/Business_account/Dashboard/VideoTutorial/VideoCard.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }


    },
    {
        path: 'VideoPlayerDialog',
        name: 'VideoPlayerDialog',
        component: () => import('../views/Business_account/Dashboard/VideoTutorial/VideoPlayerDialog.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }


    },
    {
        path: '/business-account/RequestHistory',
        name: 'Business_account_withdrawals.RequestHistory',
        component: () => import('../views/Business_account/Withdrawals/RequestHistory.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }

    },
    {
        path: '/business-account/RequestHistory2',
        name: 'Business_account_Deposit.RequestHistory',
        component: () => import('../views/Business_account/Deposits/DepositHistory.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        }

    },






    // Dashboard Sections

    // Contact Us
    {
        path: 'contact-us',
        name: 'contact_us',
        component: () => import('../views/Business_account/ContactUs/Index'),
        meta: {
            layout: 'VuebaseLayout2',

        },
    },

    // Legal Bindings
    {
        path: 'legal-bindings',
        name: 'legal_bindings',
        component: () => import('../views/Business_account/LegalBindings/Index'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true,
        },
    },
    // savings home page links
    {
        path: '/savings',
        name: 'savings.home',
        component: () => import('../views/Savings/Home'),

    },

    // savings referrals pages links
    {
        path: '/savings/referrals',
        name: 'referrals',
        component: () => import('../views/Savings/Referrals/Layout'),
        beforeEnter: async (to, from, next) => {
            if (!store.state.isAuthenticated) {
                next({ name: 'login', query: { to: to.path } });
                return;
            }
            const eligible = await store.dispatch('loadPartnerEligibility');
            if (!eligible) {
                store.commit('setSnackBarMessage', "The Referrals page is reserved for Business Suite partners.");
                store.commit('setSnackBarColor', "red darken-4");
                store.commit('activateSnackBar', true);
                next({ path: '/savings' });
            } else {
                next();
            }
        },
        children: [
            {
                path: 'dashboard',
                name: 'referrals.dashboard',
                component: () => import('../views/Savings/Referrals/Dashboard')
            },
            {
                path: 'earnings',
                name: 'referrals.earnings',
                component: () => import('../views/Savings/Referrals/Earnings')
            }
        ],
        meta: {
            requireLogin: true
        }
    },
    // savings campaign pages links
    {
        path: '/savings/campaigns',
        name: 'campaigns',
        component: () => import('../views/Savings/Campaigns/Layout'),
        children: [
            {
                path: ':category',
                name: 'campaigns.:category',
                component: () => import('../views/Savings/Campaigns/All')
            },
            {
                path: 'create/new_campaign',
                name: 'campaigns.new_campaign',
                component: () => import('../views/Savings/Campaigns/NewCampaign')
            },
            {
                path: 'detail/:campaign_id',
                name: 'campaigns.:campaign_id',
                component: () => import('../views/Savings/Campaigns/Campaign')
            },
            {
                path: 'save/:campaign_id',
                name: 'campaigns.save:campaign_id',
                component: () => import('../views/Savings/Campaigns/SaveNow')
            }
        ],
        meta: {
            requireLogin: true
        }

    },

    // savings loans pages links
    {
        path: '/savings/loans',
        name: 'loans',
        component: () => import('../views/Savings/Loans/Layout'),
        children: [
            {
                path: ':category',
                name: 'loans.:category',
                component: () => import('../views/Savings/Loans/All')
            },
            {
                path: 'create/new_loan',
                name: 'loans.new_loan',
                component: () => import('../views/Savings/Loans/NewLoan')
            },
            {
                path: 'detail/:loan_id',
                name: 'loans.:loan_id',
                component: () => import('../views/Savings/Loans/Loan')
            },
            {
                path: 'save/:loan_id',
                name: 'loans.save:loan_id',
                component: () => import('../views/Savings/Loans/SaveNow')
            }
        ],
        meta: {
            requireLogin: true
        }

    },

    // savings transactions pages links
    {
        path: '/savings/transactions',
        name: 'savings_transactions',
        component: () => import('../views/Savings/Transactions/Layout'),
        children: [
            {
                path: ':category',
                name: 'savings_transactions.:category',
                component: () => import('../views/Savings/Transactions/All')
            },
        ],
        meta: {
            requireLogin: true
        }
    },

    // savings withdrawals pages links
    {
        path: '/Savings/withdrawals',
        name: 'savings_withdrawals',
        component: () => import('../views/Savings/Withdrawals/Layout'),
        children: [
            {
                path: 'request',
                name: 'savings_withdrawals.request',
                component: () => import('../views/Savings/Withdrawals/Request'),
                beforeEnter: async (to, from, next) => {
                    try {




                        const response2 = await axios.get('/api/v1/savings/user-email2/');
                        // Vérifier si l'OTP est vérifié
                        if (!response2.data.email && to.name !== '') {
                            console.warn("Email non trouvé, redirection...");
                            // Vérifier si nous ne sommes pas déjà sur la route "Verification"
                            if (to.name !== 'Check_email') {
                                return next({ name: 'Check_email' });
                            }
                        }


                        const response = await axios.get('/api/v1/savings/check-otp/');
                        // Vérifier si l'OTP est vérifié
                        if (!response.data.otpverified && to.name !== 'Check_otp') {
                            console.warn("OTP non vérifié. Redirection vers Verification.");
                            // Vérifier si nous ne sommes pas déjà sur la route "Verification"
                            if (to.name !== 'Check_otp') {
                                return next({ name: 'Check_otp' });
                            }
                        }


                        // Si tout est valide, autoriser la navigation
                        next();
                    } catch (error) {
                        console.error("Erreur lors des vérifications de navigation :", error);
                        return next({ name: 'Check_email' }); // Rediriger en cas d'erreur
                    }
                }
            },



            {
                path: 'fees',
                name: 'savings_withdrawals.fees',
                component: () => import('../views/Savings/Withdrawals/Fees')
            },
            {
                path: 'info',
                name: 'savings_withdrawals.info',
                component: () => import('../views/Savings/Withdrawals/Info')
            },
            {
                path: 'Check_otp',
                name: 'Check_otp',
                component: () => import('../views/Savings/Withdrawals/Check_otp'),
            },

            {
                path: 'Check_email',
                name: 'Check_email',
                component: () => import('../views/Savings/Withdrawals/Check_email')

            },
            {
                path: 'history',
                name: 'savings_withdrawals.history',
                component: () => import('../views/Savings/Withdrawals/RequestHistory')
            }
        ],
        meta: {
            requireLogin: true
        }
    },

    // savings contact us page links
    {
        path: '/savings/contact_us',
        name: 'savings.contact_us',
        component: () => import('../views/Savings/Contact_us/Layout'),
        children: [
            {
                path: 'all',
                name: 'savings.contact_us.all',
                component: () => import('../views/Savings/Contact_us/All')
            },
            {
                path: 'new_ticket',
                name: 'savings.contact_us.new_ticket',
                component: () => import('../views/Savings/Contact_us/NewTicket')
            },
            {
                path: 'detail/:ticket_id',
                name: 'savings.contact_us.:ticket_id',
                component: () => import('../views/Savings/Contact_us/TicketChat')
            },
        ],
        meta: {
            requireLogin: true
        }
    },
    // savings investment pages links
    {
        path: '/savings/investments/create',
        name: 'investments.create',
        component: () =>
            import('../views/Savings/investisment/CreateInvestisment.vue'),
        meta: {
            requireLogin: true,
            title: 'Création investissement',
        },
    },
    // ✅ Ajouter cette route dans votre router/index.js

    {
        path: '/savings/investments/:investment_id/payments-history',
        name: 'investments.payments.history',
        component: () => import('@/views/Savings/investisment/InvestmentHistory.vue'),
        meta: {
            requireLogin: true,
            title: 'Payment History'
        }
    },
    {
        path: '/savings/investments',
        name: 'investments.list',
        component: () => import('@/views/Savings/investisment/All.vue'),
        meta: {

            requireLogin: true,
        },
    },
    // Route 1 - SaveNow
    {
        path: '/savings/investments/:investment_id',
        name: 'SavingsInvestismentSaveNow',
        component: () => import('@/views/Savings/investisment/SaveNow.vue'),
        meta: {
            requireLogin: true,
        },
    },
    {
        path: '/savings/investors',
        name: 'InvestorsOverview',
        component: () => import('@/views/Savings/investisment/InvestismentGroup.vue'),
        meta: {
            requireLogin: true,
        },
    },


    // Route 2 - InvestmentDetail
    {
        path: '/savings/investments/detail/:investment_id',
        name: 'SavingsInvestismentDetail',
        component: () => import('@/views/Savings/investisment/InvestismentDetail.vue'),
        meta: {
            requireLogin: true,
        },
    },
    {
        // Page de paiement (mensuel avec payment_id)
        path: '/savings/investments/pay/:investment_id/:payment_id?',
        name: 'SaveNow',
        component: () => import('@/views/Savings/investisment/SaveNow.vue'),
        meta: {
            requireLogin: true,
        },
    },
    {
        // Page de paiement - DOIT être APRÈS la route details
        // Cette route gère à la fois le paiement unique ET le paiement mensuel
        path: '/savings/investments/pay/:investment_id/:payment_id?',
        name: 'savings.investments.payment',
        component: () => import('@/views/Savings/investisment/SaveNow.vue'),
        meta: {
            requireLogin: true,
        },
    },
    // savings legal binding page links
    {
        path: '/savings/legal_binding',
        name: 'savings.legal_binding',
        component: () => import('../views/Savings/LegalBinding/Layout'),
        children: [
            {
                path: 'all',
                name: 'savings.legal_binding.all',
                component: () => import('../views/Savings/LegalBinding/All')
            },
            {
                path: 'detail/:key',
                name: 'savings.legal_binding.:key',
                component: () => import('../views/Savings/LegalBinding/TermDetail')
            },
        ],
        meta: {
            requireLogin: true
        }

    },


    // market place home page links
    {
        path: '/market_place',
        name: 'market_place.home',
        component: () => import('../views/MarketPlace/Home'),
    },
    {
        path: '/market_place/bills/payment',
        name: 'BillsPayment',
        component: () => import('@/views/MarketPlace/Bills/Payment.vue')
    },
    {
        path: '/market_place/create-campaigns',
        name: 'CreateCampaigns',
        component: () => import('@/views/MarketPlace/Campaigns/MyCampaigns.vue'),

    },
    {
        path: '/market_place/campaign/',
        name: 'market_place_campaign_purchase_create',
        component: () => import('@/views/MarketPlace/Campaigns/Layout.vue'),
        children: [
            {
                path: ':category',   // dynamique
                name: 'campaigns.category',
                component: () => import('@/views/MarketPlace/Campaigns/All.vue')  // une seule vue DRY pour toutes les catégories
            },
            {
                path: 'create/new_campaign',
                name: 'campaigns.new_campaign',
                component: () => import('../views/MarketPlace/Campaigns/NewCampaign')
            },
            {
                path: 'detail/:campaign_id',
                name: 'campaigns.:campaign_id',
                component: () => import('../views/MarketPlace/Campaigns/Campaign')
            },
            {
                path: 'save/:campaign_id',
                name: 'campaigns.save:campaign_id',
                component: () => import('../views/MarketPlace/Campaigns/SaveNow')
            },

        ],
        meta: {

            title: 'Create Campaign Purchase'
        }
    },

    // market_place items pages links
    {
        path: '/market_place/items',
        name: 'items',
        component: () => import('../views/MarketPlace/Items/Layout'),
        children: [
            {
                path: 'types/:type',
                name: 'items.:type',
                component: () => import('../views/MarketPlace/Items/All')
            },
            {
                path: 'category/:categoryId/:type?',
                name: 'items.category',
                component: () => import('../views/MarketPlace/Items/All')
            },
            {
                path: ':key',
                name: 'items.:key',
                component: () => import('../views/MarketPlace/Items/Detail')
            },
        ],
    },

    // market_place recommended products (from manager chat)
    {
        path: '/market_place/recommended/:messageId',
        name: 'recommended_products',
        component: () => import('../views/MarketPlace/Recommended/RecommendedProducts')
    },

    // market_place my shopping bag pages links
    {
        path: '/market_place/shopping_bag/items',
        name: 'my_chart',
        component: () => import('../views/MarketPlace/MyChart/Layout'),
        children: [
            {
                path: 'my_items',
                name: 'my_chart.my_items',
                component: () => import('../views/MarketPlace/MyChart/MyItems')
            },
            {
                path: 'pay_now/:requested_order_id',
                name: 'my_chart.pay_now.:requested_order_id',
                component: () => import('../views/MarketPlace/MyChart/PayNow'),
                meta: {
                    requireLogin: true
                }
            },
            {
                path: 'transactions/make_payment/:requested_order_id',
                name: 'my_chart.make_payment.:requested_order_id',
                component: () => import('../views/MarketPlace/MyChart/MakePayment'),
                meta: {
                    requireLogin: true
                }
            },
            {
                path: 'transactions',
                name: 'my_chart.transactions',
                component: () => import('../views/MarketPlace/MyChart/Transactions'),
                meta: {
                    requireLogin: true
                }
            },
            {
                path: 'transactions/:requested_order_id',
                name: 'my_chart.transactions.:requested_order_id',
                component: () => import('../views/MarketPlace/MyChart/TransactionDetail'),
                meta: {
                    requireLogin: true
                }
            },
            {
                path: 'billing_info',
                name: 'my_chart.billing_info',
                component: () => import('../views/MarketPlace/MyChart/BillingReceipt'),
                meta: {
                    requireLogin: true
                }
            },
        ],
    },

    // market_place my shopping history pages links,
    {
        path: '/market_place/history/items',
        name: 'shopping_history',
        component: () => import('../views/MarketPlace/History/Layout'),
        children: [
            {
                path: 'types/:type',
                name: 'shopping_history.my_items.:type',
                component: () => import('../views/MarketPlace/History/All')
            },
            {
                path: ':key',
                name: 'shopping_history.:key',
                component: () => import('../views/MarketPlace/History/ShoppingDetail')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // market place contact us page links
    {
        path: '/market_place/contact_us',
        name: 'market_place.contact_us',
        component: () => import('../views/MarketPlace/Contact_us/Layout'),
        children: [
            {
                path: 'all',
                name: 'market_place.contact_us.all',
                component: () => import('../views/MarketPlace/Contact_us/All')
            },
            {
                path: 'new_ticket',
                name: 'market_place.contact_us.new_ticket',
                component: () => import('../views/MarketPlace/Contact_us/NewTicket')
            },
            {
                path: 'detail/:ticket_id',
                name: 'market_place.contact_us.:ticket_id',
                component: () => import('../views/MarketPlace/Contact_us/TicketChat')
            },
        ],
        meta: {
            requireLogin: true
        }
    },

    // market place legal binding page links
    {
        path: '/market_place/legal_binding',
        name: 'market_place.legal_binding',
        component: () => import('../views/MarketPlace/LegalBinding/Layout'),
        children: [
            {
                path: 'all',
                name: 'market_place.legal_binding.all',
                component: () => import('../views/MarketPlace/LegalBinding/All')
            },
            {
                path: 'detail/:key',
                name: 'market_place.legal_binding.:key',
                component: () => import('../views/MarketPlace/LegalBinding/TermDetail')
            },
        ],
        meta: {
            requireLogin: true
        }
    },

    // ── BUSINESS ACCOUNT SELLER ROUTES ──────────────────────────────────────
    {
        path: '/business-account/market_place/seller',
        name: 'business_seller',
        redirect: '/business-account/market_place/seller/dashboard',
        component: () => import('../views/Business_account/seller/Layout.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        },
        children: [
            {
                path: 'apply',
                name: 'business_seller.apply',
                component: () => import('../views/Business_account/seller/SellerApplication.vue')
            },
            {
                path: 'dashboard',
                name: 'business_seller.dashboard',
                component: () => import('../views/Business_account/seller/SellerDashboard.vue')
            },
            {
                path: 'products',
                name: 'business_seller.products',
                component: () => import('../views/Business_account/seller/SellerProducts.vue')
            },
            {
                path: 'add-product',
                name: 'business_seller.add_product',
                component: () => import('../views/Business_account/seller/SellerAddProduct.vue')
            }
        ]
    },

    // ── BUSINESS ACCOUNT RESELLER ROUTES ────────────────────────────────────
    {
        path: '/business-account/market_place/reseller',
        name: 'business_reseller',
        redirect: '/business-account/market_place/reseller/dashboard',
        component: () => import('../views/Business_account/reseller/Layout.vue'),
        meta: {
            layout: 'VuebaseLayout2',
            requireLogin: true
        },
        children: [
            {
                path: 'apply',
                name: 'business_reseller.apply',
                component: () => import('../views/Business_account/reseller/ResellerApplication.vue')
            },
            {
                path: 'dashboard',
                name: 'business_reseller.dashboard',
                component: () => import('../views/Business_account/reseller/ResellerDashboard.vue')
            },
            {
                path: 'products',
                name: 'business_reseller.products',
                component: () => import('../views/Business_account/reseller/ResellerProducts.vue')
            }
        ]
    },

    // savings money transfer page links
    {
        path: '/savings/money_transfer',
        component: () => import('../views/Savings/MoneyTransfer/Layout.vue'),
        redirect: '/savings/money_transfer/send',
        children: [
            {
                path: 'send',
                name: 'savings.money_transfer.send',
                component: () => import('../views/Savings/MoneyTransfer/Send')
            },
            {
                path: 'sent_history',
                name: 'savings.money_transfer.sent_history',
                component: () => import('../views/Savings/MoneyTransfer/SentHistory')
            },
            {
                path: 'received_history',
                name: 'savings.money_transfer.received_history',
                component: () => import('../views/Savings/MoneyTransfer/ReceivedHistory')
            }
        ],
        meta: {
            requireLogin: true
        }
    },


    // njangi home page links
    {
        path: '/njangi',
        name: 'njangi.home',
        component: () => import('../views/Njangi/Home'),
    },
    // router/index.js
    {
        path: '/business-account/dashboard/create-njangi-group',
        name: 'create_njangi_group',
        component: () => import('../views/Njangi/CreateGroup'),
        meta: { requiresAuth: true }
    },
    {
        path: 'njangi/join/:token',
        name: 'join_njangi_group',
        component: () => import('../views/Njangi/JoinGroup')
    },
    {
        path: '/business-account/dashboard/njangi/admin/groups',
        name: 'ManageAdminGroups',
        component: () => import('../views/Njangi/ManageAdminGroups.vue'),
        meta: {
            requiresAuth: true,
            title: 'Gérer Mes Groupes'
        }
    },

    // ===== INVITATIONS =====

    // Liste des invitations reçues
    {
        path: '/njangi/invitations',
        name: 'NjangiInvitations',
        component: () => import('../views/Njangi/JoinGroup'),
        meta: {
            requiresAuth: true,
            title: 'Mes Invitations'
        }
    },
    // njangi groups pages links 
    {
        path: '/njangi/groups',
        name: 'njangi_groups',
        component: () => import('../views/Njangi/Groups/Layout'),
        children: [
            {
                path: 'types/:category',
                name: 'njangi_groups.:category',
                component: () => import('../views/Njangi/Groups/All')
            },
            {
                path: 'groups/:group_id/chat',
                name: 'njangi_group_chat',
                component: () => import('../views/Njangi/Groups/GroupChat.vue')
            },
            {
                path: 'detail/:key',
                name: 'njangi_groups.:key',
                component: () => import('../views/Njangi/Groups/Detail')
            },
            {
                path: 'detail/:key/pause',
                name: 'njangi_groups.detail_weekly_pause',
                component: () => import('../views/Njangi/Groups/GroupDetailWeeklyPause.vue')
            },
            {
                path: 'terminate/:key',
                name: 'njangi_groups.terminate:key',
                component: () => import('../views/Njangi/Groups/TerminateNow')
            },
            {
                path: 'new_group',
                name: 'njangi_groups.new_group',
                component: () => import('../views/Njangi/Groups/NewGroup')
            },
            {
                path: 'new_group/one',
                name: 'njangi_groups.new_group_one',
                component: () => import('../views/Njangi/Groups/NewGroupStepOne')
            },
            {
                path: 'new_group/two/:application_id',
                name: 'njangi_groups.new_group_two.:application_id',
                component: () => import('../views/Njangi/Groups/NewGroupStepTwo')
            },
            {
                path: 'new_group/three/',
                name: 'njangi_groups.new_group_three',
                component: () => import('../views/Njangi/Groups/NewGroupStepThree')
            },
            {
                path: 'contribute/:group_id',
                name: 'njangi_groups.contribute:group_id',
                component: () => import('../views/Njangi/Groups/SaveNow')
            },
            {
                path: 'configure/detail/:new_group_id',
                name: 'njangi_groups.configure.:new_group_id',
                component: () => import('../views/Njangi/Groups/DetailConfiguration')
            },
            {
                path: 'complaints/:new_group_id',
                name: 'njangi_groups.complaints.:new_group_id',
                component: () => import('../views/Njangi/Groups/Complaints')
            },
            {
                path: 'cancel/group/:new_group_id',
                name: 'njangi_groups.cancel.:new_group_id',
                component: () => import('../views/Njangi/Groups/CancelNjangi')
            },
            {
                path: 'membership/:new_group_id',
                name: 'njangi_groups.membership.:new_group_id',
                component: () => import('../views/Njangi/Groups/MembershipSetting')
            },

        ],
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/njangi/my-collection-history',
        name: 'njangi.my_collection_history',
        component: () => import('../views/Njangi/Groups/MyCollectionHistory.vue'),
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/njangi/groups/join_us',
        name: 'njangi_groups_join_us',
        component: () => import('../views/Njangi/Groups/Layout'),
        children: [
            {
                path: 'invitation/:new_group_id',
                name: 'njangi_groups_join_us.invitation.:new_group_id',
                component: () => import('../views/Njangi/Groups/acceptInvitation.vue')
            },
        ]
    },

    // njangi withdrawals pages links
    {
        path: '/njangi/withdrawals',
        name: 'njangi_withdrawals',
        component: () => import('../views/Njangi/Withdrawals/Layout'),
        children: [

            {
                path: 'request',
                name: 'njangi_withdrawals.request',
                component: () => import('../views/Njangi/Withdrawals/Request'),
                beforeEnter: async (to, from, next) => {
                    try {


                        const response2 = await axios.get('/api/v1/savings/user-email2/');
                        // Vérifier si l'OTP est vérifié
                        if (!response2.data.email && to.name !== '') {
                            console.warn("Email non trouvé, redirection...");
                            // Vérifier si nous ne sommes pas déjà sur la route "Verification"
                            if (to.name !== 'Check_email_njangi') {
                                return next({ name: 'Check_email_njangi' });
                            }
                        }

                        const response = await axios.get('/api/v1/savings/check-otp/');

                        if (!response.data.otpverified && to.name !== 'Check_otp_njangi') {
                            console.warn("OTP non vérifié. Redirection vers Verification.");

                            if (to.name !== 'Check_otp_njangi') {
                                return next({ name: 'Check_otp_njangi' });
                            }
                        }

                        next();
                    } catch (error) {
                        console.error("Erreur lors des vérifications de navigation :", error);
                        return next({ name: 'Check_email_njangi' });
                    }
                }
            },
            {
                path: 'fees',
                name: 'njangi_withdrawals.fees',
                component: () => import('../views/Njangi/Withdrawals/Fees')
            },
            {
                path: 'info',
                name: 'njangi_withdrawals.info',
                component: () => import('../views/Njangi/Withdrawals/Info')
            },



            {
                path: 'history',
                name: 'njangi_withdrawals.history',
                component: () => import('../views/Njangi/Withdrawals/RequestHistory')
            },

            {
                path: 'Check_otp_njangi',
                name: 'Check_otp_njangi',
                component: () => import('../views/Njangi/Withdrawals/Check_otp_njangi'),
            },

            {
                path: 'Check_email_njangi',
                name: 'Check_email_njangi',
                component: () => import('../views/Njangi/Withdrawals/Check_email_njangi')

            },

        ],
        meta: {
            requireLogin: true
        }
    },

    // njangi contact us page links
    {
        path: '/njangi/contact_us',
        name: 'njangi.contact_us',
        component: () => import('../views/Njangi/Contact_us/Layout'),
        children: [
            {
                path: 'all',
                name: 'njangi.contact_us.all',
                component: () => import('../views/Njangi/Contact_us/All')
            },
            {
                path: 'new_ticket',
                name: 'njangi.contact_us.new_ticket',
                component: () => import('../views/Njangi/Contact_us/NewTicket')
            },
            {
                path: 'detail/:ticket_id',
                name: 'njangi.contact_us.:ticket_id',
                component: () => import('../views/Njangi/Contact_us/TicketChat')
            },
        ],
        meta: {
            requireLogin: true
        }
    },

    // njangi legal binding page links
    {
        path: '/njangi/legal_binding',
        name: 'njangi.legal_binding',
        component: () => import('../views/Njangi/LegalBinding/Layout'),
        children: [
            {
                path: 'all',
                name: 'njangi.legal_binding.all',
                component: () => import('../views/Njangi/LegalBinding/All')
            },
            {
                path: 'detail/:key',
                name: 'njangi.legal_binding.:key',
                component: () => import('../views/Njangi/LegalBinding/TermDetail')
            },
        ],
        meta: {
            requireLogin: true
        }
    },

    // funding home page links
    {
        path: '/funding',
        name: 'funding.home',
        component: () => import('../views/Fundraising/Home'),
    },

    // funding projects pages links
    {
        path: '/funding/projects',
        name: 'funding_projects',
        component: () => import('../views/Fundraising/Projects/Layout'),
        children: [
            {
                path: 'types/:type',
                name: 'funding_projects.:type',
                component: () => import('../views/Fundraising/Projects/All')
            },
            {
                path: ':key',
                name: 'funding_projects.:key',
                component: () => import('../views/Fundraising/Projects/Detail')
            },
            {
                path: 'terminate/:key',
                name: 'funding_projects.terminate:key',
                component: () => import('../views/Fundraising/Projects/TerminateNow')
            },
            {
                path: 'new_project',
                name: 'funding_projects.new_project',
                component: () => import('../views/Fundraising/Projects/NewProject')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // funding events pages links
    {
        path: '/funding/events',
        name: 'funding_events',
        component: () => import('../views/Fundraising/Events/Layout'),
        children: [
            {
                path: 'types/:type',
                name: 'funding_events.:type',
                component: () => import('../views/Fundraising/Events/All')
            },
            {
                path: ':key',
                name: 'funding_events.:key',
                component: () => import('../views/Fundraising/Events/Detail')
            },
            {
                path: 'terminate/:key',
                name: 'funding_events.terminate:key',
                component: () => import('../views/Fundraising/Events/TerminateNow')
            },
            {
                path: 'new_event',
                name: 'funding_events.new_event',
                component: () => import('../views/Fundraising/Events/NewEvent')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // funding contact us page links
    {
        path: '/funding/contact_us',
        name: 'funding.contact_us',
        component: () => import('../views/Fundraising/Contact_us/Layout'),
        children: [
            {
                path: 'all',
                name: 'funding.contact_us.all',
                component: () => import('../views/Fundraising/Contact_us/All')
            },
            {
                path: 'new_ticket',
                name: 'funding.contact_us.new_ticket',
                component: () => import('../views/Fundraising/Contact_us/NewTicket')
            },
            {
                path: 'detail/:ticket_id',
                name: 'funding.contact_us.:ticket_id',
                component: () => import('../views/Fundraising/Contact_us/TicketChat')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // funding legal binding page links
    {
        path: '/funding/legal_binding',
        name: 'funding.legal_binding',
        component: () => import('../views/Fundraising/LegalBinding/Layout'),
        children: [
            {
                path: 'all',
                name: 'funding.legal_binding.all',
                component: () => import('../views/Fundraising/LegalBinding/All')
            },
            {
                path: 'detail/:key',
                name: 'funding.legal_binding.:key',
                component: () => import('../views/Fundraising/LegalBinding/TermDetail')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // monitor home page links
    {
        path: '/monitor',
        name: 'monitor.home',
        component: () => import('../views/Monitor/Home'),
    },

    // monitor dashboard pages links
    {
        path: '/monitor/dashboard',
        name: 'monitor_dashboard',
        component: () => import('../views/Monitor/MyDashboard/Layout'),
        children: [
            {
                path: ':type',
                name: 'monitor_dashboard.:type',
                component: () => import('../views/Monitor/MyDashboard/All')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // monitor expenses pages links
    {
        path: '/monitor/expense',
        name: 'monitor_expense',
        component: () => import('../views/Monitor/MyExpense/Layout'),
        children: [
            {
                path: ':type',
                name: 'monitor_expenses.:type',
                component: () => import('../views/Monitor/MyExpense/All')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // monitor income pages links
    {
        path: '/monitor/income',
        name: 'monitor_income',
        component: () => import('../views/Monitor/MyIncome/Layout'),
        children: [
            {
                path: ':type',
                name: 'monitor_income.:type',
                component: () => import('../views/Monitor/MyIncome/All')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // monitor contact us page links
    {
        path: '/monitor/contact_us',
        name: 'monitor.contact_us',
        component: () => import('../views/Monitor/Contact_us/Layout'),
        children: [
            {
                path: 'all',
                name: 'monitor.contact_us.all',
                component: () => import('../views/Monitor/Contact_us/All')
            },
            {
                path: 'new_ticket',
                name: 'monitor.contact_us.new_ticket',
                component: () => import('../views/Monitor/Contact_us/NewTicket')
            },
            {
                path: 'detail/:ticket_id',
                name: 'monitor.contact_us.:ticket_id',
                component: () => import('../views/Monitor/Contact_us/TicketChat')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

    // monitor legal binding page links
    {
        path: '/monitor/legal_binding',
        name: 'monitor.legal_binding',
        component: () => import('../views/Monitor/LegalBinding/Layout'),
        children: [
            {
                path: 'all',
                name: 'monitor.legal_binding.all',
                component: () => import('../views/Monitor/LegalBinding/All')
            },
            {
                path: 'detail/:key',
                name: 'monitor.legal_binding.:key',
                component: () => import('../views/Monitor/LegalBinding/TermDetail')
            },
        ],
        meta: {
            requireLogin: true
        }

    },

]






const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {


    if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
        store.commit('initialiseStore')
    }

    if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
        next({ name: 'login', query: { to: to.path } });
        store.commit('setSnackBarMessage', "Login is required: Please log into your account or create on now.")
        store.commit('setSnackBarColor', "red darken-4")
        store.commit('activateSnackBar', true)
    }
    else {
        const token = store.state.token
        if (token) {
            axios.defaults.headers.common['Authorization'] = "Token " + token
        } else {
            axios.defaults.headers.common['Authorization'] = ""
        }

        if (to.path === from.path) {
            return next(false); // cancel redundant nav
        }

        if (to.path.includes("/funding/") || to.path.includes("/monitor/")) {
            store.commit('activateDialog', true)
            store.commit('setDialogTitle', "Coming Soon 😊 ....")
            store.commit('setDialogMessage', "<div > <span style='float: left; font-size: 38px!important' >🛠️</span> <p style='text-align: justify;'>Our Fundraising and Financial Monitor services are still under construction for you.</p></div>")

            next({ name: 'All', query: { to: to.path } });
        }

        next()
    }
})
export default router

